// Guest grants approved explicitly for these upper-management roles.
export const MY_GUEST_UPPER_MANAGEMENT = ['owner','coo','cfo','district_leader'];
export const MY_GUEST_BOUTIQUES = ['PLT','FLL','WYN','PNC','RNO','CC'];
export const MY_GUEST_ROLES = ['massage_therapist','front_desk','experience_guide','boutique_manager',...MY_GUEST_UPPER_MANAGEMENT];
export const myGuestsAvailable = user => MY_GUEST_ROLES.includes(user?.role);
